import React from 'react';
import { Text } from '@raptormaps/text';
import { Button } from '@raptormaps/button';
import {
  Breadcrumb,
  PageHeaderLeft,
  PageHeaderRight,
  PageHeaderRow,
  TitleRow,
  ActiveBadge,
} from './OrgDetails.styles';

interface OrgPageHeaderProps {
  orgName: string;
  onEdit: () => void;
}

export function OrgPageHeader({ orgName, onEdit }: OrgPageHeaderProps) {
  return (
    <PageHeaderRow>
      <PageHeaderLeft>
        <Breadcrumb>Organization View &bull; {orgName}</Breadcrumb>
        <TitleRow>
          <Text variant="h1">{orgName}</Text>
          <ActiveBadge>Active</ActiveBadge>
        </TitleRow>
      </PageHeaderLeft>
      <PageHeaderRight>
        <Button variant="primary" onClick={onEdit}>
          Edit Organization
        </Button>
      </PageHeaderRight>
    </PageHeaderRow>
  );
}
